import { render, staticRenderFns } from "./SearchChipsContainer.vue?vue&type=template&id=56a930c5&scoped=true"
import script from "./SearchChipsContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchChipsContainer.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a930c5",
  null
  
)

export default component.exports